import { z } from "zod";
/** A month as a zoneless `YYYY-MM` value. */
export const monthSchema = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, "Expected YYYY-MM");
/** A monetary amount as a decimal string, to avoid floating-point rounding on the wire. */
export const amountSchema = z.string().regex(/^-?\d+(\.\d+)?$/, "Expected a decimal number");
/** An ISO 8601 timestamp with a UTC offset. */
export const timestampSchema = z.iso.datetime({ offset: true });
/** A key-value label as UpCloud represents it. */
export const labelSchema = z.object({
    key: z.string().min(1).max(255),
    value: z.string().max(255),
});
/** Error response shape of every API endpoint. */
export const errorResponseSchema = z.object({
    code: z.string(),
    details: z.string().optional(),
    fieldErrors: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
    correlationId: z.string().optional(),
});
//# sourceMappingURL=primitives.js.map